import { useMutation, useQuery, useSubscription } from "@apollo/react-hooks";
import {
  Button,
  Col,
  Empty,
  message,
  Tooltip,
  Progress,
  Row,
  Select,
} from "antd";
import moment from "moment-timezone";
import React, { Fragment, useEffect, useState } from "react";
import Empty_NoTask from "../../../Assets/Images/Empty/Empty_NoTask.svg";
import TaskVector from "../../../Assets/Images/TaskVector.svg";
import PictureRequiredAttachmentDrawer from "../../../Components/Drawers/PictureRequiredAttachment/PictureRequiredAttachment";
import { Loader } from "../../../Components/Loader";
import { CancelTaskModal } from "../../../Components/Modals/CancelTaskModal";
import { ViewTutorialModal } from "../../../Components/Modals/ViewTutorialModal/ViewTutorialModal";
import { CustIcon } from "../../../Components/Svgs";
import { UPDATE_TASK_STATUS } from "../../../Graphql/mutations";
import { GET_USER_TIMEZONE } from "../../../Graphql/queries";
import {
  GET_USERS_TASKS_LIST,
  GET_USER_WORKING_SHIFT,
} from "../../../Graphql/subscriptions";
import { Announcement } from "../../Dashboard/Announcement/Announcement";
import "./TaskList.less";

const { Option } = Select;

const { REACT_APP_ASSETS_URL } = process.env;

export const TaskList = ({ userData }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [completePercentage, setCompletePercentage] = useState(0);
  const [isCancelModalVisible, setIsCancelModalVisible] = useState(false);
  const [isTutorialModalVisible, setIsTutorialModalVisible] = useState(false);
  const [filteredTasks, setFilteredTasks] = useState([]);
  const [typeFilter, setTypeFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [taskId, setTaskId] = useState("");
  const [tutorialType, setTutorialType] = useState("");
  const [tutorialUrl, setTutorialUrl] = useState("");
  const [allowEODUpdate, setAllowEODUpdate] = useState(undefined);
  const [singleTaskDetails, setSingleTaskDetails] = useState(undefined);

  const [
    isPictureRequiredAttachmentVisible,
    setIsPictureRequiredAttachmentVisible,
  ] = useState(false);

  const userTypeId = userData?.getUsersById?.user_access?.access_id;
  const userName =
    userData?.getUsersById?.first_name +
    " " +
    userData?.getUsersById?.first_name;

  const { data: userTimeZoneData, loading: userTimeZoneDataLoading } = useQuery(
    GET_USER_TIMEZONE,
    { variables: { user_id: localStorage.getItem("user_id") } }
  );
  const { data: userTasksData, loading: isUserTasksDataLoading } =
    useSubscription(GET_USERS_TASKS_LIST, {
      variables: {
        user_id: localStorage.getItem("user_id"),
        todaysDate: moment()
          .tz(userTimeZoneData?.getUsersById?.time_zone)
          ?.format("YYYY-MM-DD"),
      },
      shouldResubscribe: true,
      skip: userTimeZoneDataLoading,
      fetchPolicy: "cache-and-network",
    });

  const { data: userShift } = useSubscription(GET_USER_WORKING_SHIFT, {
    variables: {
      user_id: localStorage.getItem("user_id"),
      working_day: moment()
        .tz(userTimeZoneData?.getUsersById?.time_zone)
        ?.format("dddd"),
    },
    shouldResubscribe: true,
    skip: userTimeZoneDataLoading,
    fetchPolicy: "cache-and-network",
  });

  const [UPDATE_TASK_STATUS_MUTATION, { loading: isUpdatingTask }] =
    useMutation(UPDATE_TASK_STATUS);

  useEffect(() => {
    if (userTasksData && userShift && userTimeZoneData) {
      formatTasks();
    }
  }, [userTasksData, userShift, userTimeZoneData]);

  const calculateEndOfShiftTime = () => {
    if (!userShift.user_shift_by_pk) {
      return Promise.resolve(true);
    }
    // let duration = moment
    //   .tz(
    //     userShift.user_shift_by_pk.end_time,
    //     "HH:mm:ss",
    //     userTimeZoneData?.getUsersById?.time_zone
    //   )
    //   .diff(
    //     moment.tz(
    //       userShift.user_shift_by_pk.start_time,
    //       "HH:mm:ss",
    //       userTimeZoneData?.getUsersById?.time_zone
    //     ),
    //     "seconds"
    //   );
    // let eod_duration = (duration * 90) / 100;
    let end_time_limit = 1800; //half an hour in seconds
    let eod_time = moment
      .tz(
        userShift.user_shift_by_pk.end_time,
        "HH:mm:ss",
        userTimeZoneData?.getUsersById?.time_zone
      )
      .subtract(end_time_limit, "seconds");
    if (
      moment().tz(userTimeZoneData?.getUsersById?.time_zone).isAfter(eod_time)
    ) {
      setAllowEODUpdate(true);
    } else {
      setAllowEODUpdate(false);
    }
    return Promise.resolve(true);
  };
  const formatTasks = async () => {
    if (userTasksData?.user_tasks_map.length > 0) {
      let pendingTasksCount = userTasksData?.user_tasks_map.filter(
        (x) => x.task_status === "pending"
      ).length;
      setCompletePercentage(
        (
          100 -
          (pendingTasksCount / userTasksData?.user_tasks_map.length) * 100
        ).toFixed(0)
      );
    } else {
      setCompletePercentage(100);
      setIsLoading(false);
    }
    let formattingDone = await setTaskTypeWiseFormatting();
    const calculatedShiftTime = await calculateEndOfShiftTime();
    let taskFilter = userTasksData?.user_tasks_map;
    let filteredTaskList = [];
    if (formattingDone && calculatedShiftTime) {
      if (!!typeFilter || !!statusFilter) {
        let filteredResults = [];
        if (!!typeFilter && !!statusFilter) {
          filteredResults = taskFilter.filter(
            (x) =>
              x.task.taskType.type === typeFilter &&
              x.task_status === statusFilter
          );
        } else {
          if (!!typeFilter) {
            filteredResults = taskFilter.filter(
              (x) => x.task.taskType.type === typeFilter
            );
          }
          if (!!statusFilter) {
            filteredResults = taskFilter.filter(
              (x) => x.task_status === statusFilter
            );
          }
        }
        filteredTaskList = filteredResults;
      } else {
        filteredTaskList = taskFilter;
      }
      let taskList = [];
      let pendingTasks = filteredTaskList.filter(
        (x) => x.task_status === "pending"
      );
      taskList.push(
        ...pendingTasks.filter(
          (p) => p.task.taskType.type === "time_sensitive"
        ),
        ...pendingTasks.filter((p) => p.task.taskType.type === "reminder"),
        ...pendingTasks.filter((p) => p.task.taskType.type === "during_day"),
        ...pendingTasks.filter((p) => p.task.taskType.type === "end_of_day")
      );
      let incompleteTasks = filteredTaskList.filter(
        (x) => x.task_status === "incomplete"
      );
      taskList.push(
        ...incompleteTasks.filter(
          (p) => p.task.taskType.type === "time_sensitive"
        ),
        ...incompleteTasks.filter((p) => p.task.taskType.type === "reminder"),
        ...incompleteTasks.filter((p) => p.task.taskType.type === "during_day"),
        ...incompleteTasks.filter((p) => p.task.taskType.type === "end_of_day")
      );
      let escalatedTasks = filteredTaskList.filter(
        (x) => x.task_status === "escalated"
      );
      taskList.push(
        ...escalatedTasks.filter(
          (p) => p.task.taskType.type === "time_sensitive"
        ),
        ...escalatedTasks.filter((p) => p.task.taskType.type === "reminder"),
        ...escalatedTasks.filter((p) => p.task.taskType.type === "during_day"),
        ...escalatedTasks.filter((p) => p.task.taskType.type === "end_of_day")
      );
      let completedTasks = filteredTaskList.filter(
        (x) => x.task_status === "completed"
      );
      taskList.push(
        ...completedTasks.filter(
          (p) => p.task.taskType.type === "time_sensitive"
        ),
        ...completedTasks.filter((p) => p.task.taskType.type === "reminder"),
        ...completedTasks.filter((p) => p.task.taskType.type === "during_day"),
        ...completedTasks.filter((p) => p.task.taskType.type === "end_of_day")
      );
      setFilteredTasks(taskList);
      setIsLoading(false);
    }
  };

  const setTaskTypeWiseFormatting = () => {
    userTasksData?.user_tasks_map.forEach((singleTask) => {
      switch (singleTask.task.taskType.type) {
        default:
        case "reminder":
          singleTask.tagClass = "blueTag";
          break;
        case "time_sensitive":
          singleTask.tagClass = "redTag";
          break;
        case "end_of_day":
          singleTask.tagClass = "orangeTag";
          break;
        case "during_day":
          singleTask.tagClass = "greenTag";
          break;
      }
      switch (singleTask.task_status) {
        default:
        case "pending":
          if (
            singleTask.task.taskType.type === "end_of_day" &&
            !allowEODUpdate
          ) {
            singleTask.showOptions = false;
          } else {
            singleTask.showOptions = true;
          }
          singleTask.cardClass = "whiteCard";
          break;
        case "completed":
          singleTask.showOptions = false;
          singleTask.cardClass = "taskCompleted";
          break;
        case "incomplete":
          singleTask.showOptions = false;
          singleTask.cardClass = "taskIncomplete";
          break;
        case "escalated":
          singleTask.showOptions = false;
          singleTask.cardClass = "taskEscalated";
          break;
      }
      return true;
    });
    return Promise.resolve(true);
  };

  const handleCancelTask = (task_id) => {
    setIsCancelModalVisible(true);
    setTaskId(task_id);
  };

  const handleCompleteTask = async (taskId, details) => {
    if (details.task.user_tasks_maps[0]?.required_attachment) {
      setIsPictureRequiredAttachmentVisible(true);
      setSingleTaskDetails(details);
    } else {
      try {
        const isUpdateSuccessful = await UPDATE_TASK_STATUS_MUTATION({
          variables: {
            user_id: localStorage.getItem("user_id"),
            task_id: taskId,
            task_status: "completed",
            task_status_updated_at: new Date().toISOString(),
          },
        });
        if (!isUpdateSuccessful.errors) {
          message.success("Task Updated Successfully");
          setIsCancelModalVisible(false);
        } else {
          message.error("Something went wrong...");
        }
      } catch (error) {}
    }
  };

  const handleTutorial = ({ tutorial_type: type, tutorial_url: url }) => {
    setTutorialType(type);
    setTutorialUrl(REACT_APP_ASSETS_URL + url);
    setIsTutorialModalVisible(true);
  };

  // showRequiredAttachmentDrawer
  return (
    <section className="taskListSec">
      {userTypeId !== "1" && <Announcement />}
      <div className="userTaskSummary">
        <Row gutter={10} className="align-items-center">
          <Col
            xs={24}
            xl={6}
            className="pb-3 pb-lg-0 d-flex justify-content-center"
          >
            <img src={TaskVector} alt="" className="" />
          </Col>
          <Col xs={24} lg={16} md={15} sm={14} xl={12} className="pb-2 pb-sm-0">
            <h5 className="name">Hi, {userName?.split(" ")[0]}!</h5>
            <div className="tadkDetails">
              Manage your daily tasks from this task dashboard. Mark your task
              status as done as and when you accomplish them. Every task has
              training associated that will help you to complete that specific
              task.
            </div>
          </Col>
          <Col xs={24} lg={8} md={9} sm={10} xl={6}>
            <div className="taskSummaryCard">
              <div className="d-flex align-items-center justify-content-between">
                <h6>Task summary</h6>
                <div className="count">
                  {userTasksData
                    ? userTasksData?.user_tasks_map.filter(
                        (x) => x.task_status !== "pending"
                      ).length || 0 + "/" + userTasksData.user_tasks_map.length
                    : "0 / 0"}
                </div>
              </div>
              <div className="d-flex justify-content-center pt-3 pb-2">
                <Progress
                  type="circle"
                  width="90px"
                  strokeWidth="10"
                  strokeColor={{
                    "0%": "#8ac23b",
                    "100%": "#0d6fb7",
                  }}
                  percent={completePercentage || 0}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className="secSubTitle pageSubTilte">
        <div className="stLeft">
          <h5>Your tasks for the day</h5>
          <Tooltip
            trigger={["hover"]}
            overlayClassName="numeric-input task-detail-tooltip"
            arrowPointAtCenter
            placement="bottomLeft"
            title={() => {
              return (
                <span>
                  - For Time Sensitive Tasks-Notifications will be sent after 15
                  mins of shift start time.
                  <br />- For Reminders - Will be send randomly.
                  <br />- For During the day tasks - Notifications will be sent
                  when 40% of the day/shift is completed and 90% of the
                  day/shift is completed.
                  <br />- For End of the day tasks - Notifications will be sent
                  before half an hour of the day/shift completion time.
                </span>
              );
            }}
          >
            <div>
              <CustIcon type="info" className="ml-2" />
            </div>
          </Tooltip>
        </div>
        <div className="stright d-sm-flex align-items-sm-center">
          <label htmlFor="" className="pb-2 pb-sm-0">Filter by:</label>
          <div className=" d-flex align-items-center">
            <Select
              className="selectType"
              allowClear
              onSelect={(value) => {
                setTypeFilter(value);
              }}
              onClear={(value) => setTypeFilter(value)}
              placeholder="Select type"
            >
              <Option value="reminder">Reminder</Option>
              <Option value="time_sensitive">Time Sensitive</Option>
              <Option value="during_day">During Day</Option>
              <Option value="end_of_day">End of Day</Option>
            </Select>
            <Select
              className="selectStatus"
              style={{ width: 200 }}
              allowClear
              onSelect={(value) => {
                setStatusFilter(value);
              }}
              onClear={(value) => setStatusFilter(value)}
              placeholder="Select status"
              // optionFilterProp="children"
              // filterOption={(input, option) =>
              //   option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              // }
            >
              <Option value="completed">Completed</Option>
              <Option value="escalated">Escalated</Option>
              <Option value="incomplete">Incomplete</Option>
              <Option value="pending">Pending</Option>
            </Select>
          </div>
        </div>
      </div>
      <div className="task_blk">
        {isUserTasksDataLoading || isLoading ? (
          <Loader />
        ) : filteredTasks.length === 0 ? (
          <Empty
            className="mt-5 pt-5"
            image={Empty_NoTask}
            description={
              <span>
                Welcome, Sit back and relax! You'll see your assigned tasks once
                your manager updates them!
              </span>
            }
          />
        ) : (
          <ul className="list-inline taskListList">
            {filteredTasks.map((singleTasks, index) => (
              <li
                key={index}
                className={`d-flex flex-column myTaskList ${singleTasks.cardClass}`}
              >
                <div className="d-flex align-items-center justify-content-between">
                  <div className={`tags ${singleTasks?.tagClass}`}>
                    {singleTasks?.task.taskType?.type_name}
                  </div>
                  <div
                    className={`taskAction d-flex align-items-center ${singleTasks.task_status}`}
                  >
                    {singleTasks?.showOptions ? (
                      <Fragment>
                        {singleTasks.task.task_tutorial_maps.length > 0 && (
                          <Button
                            type="link"
                            className="d-inline-flex align-items-center viewTutorial #0D6FB7"
                            onClick={() =>
                              handleTutorial(
                                singleTasks.task.task_tutorial_maps[0].tutorial
                              )
                            }
                          >
                            <CustIcon type="tutorial" className="mr-2" />
                            <span>View tutorial</span>
                          </Button>
                        )}
                        <Button
                          disabled={isUpdatingTask}
                          type="link"
                          className="d-inline-flex ml-3 true #0D6FB7"
                          onClick={() =>
                            handleCompleteTask(
                              singleTasks.task.task_id,
                              singleTasks
                            )
                          }
                        >
                          <CustIcon type="chack" />
                        </Button>
                        <Button
                          type="link"
                          onClick={() =>
                            handleCancelTask(singleTasks.task.task_id)
                          }
                          className="d-inline-flex ml-3 false #0D6FB7"
                        >
                          <CustIcon type="close-o" />
                        </Button>
                      </Fragment>
                    ) : (
                      <span>
                        {singleTasks.task_status.charAt(0).toUpperCase() +
                          singleTasks.task_status.slice(1)}
                      </span>
                    )}
                  </div>
                </div>
                <div className="myTaskListDetails">
                  <span>{singleTasks.task.description}</span>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>

      <ViewTutorialModal
        type={tutorialType}
        src={tutorialUrl}
        visible={isTutorialModalVisible}
        onCancel={() => {
          setTutorialType("");
          setTutorialUrl("");
          setIsTutorialModalVisible(false);
        }}
      />
      <CancelTaskModal
        visible={isCancelModalVisible}
        onCancel={() => setIsCancelModalVisible(false)}
        taskId={taskId}
      />
      {isPictureRequiredAttachmentVisible && (
        <PictureRequiredAttachmentDrawer
          isPictureRequiredAttachmentVisible={
            isPictureRequiredAttachmentVisible
          }
          setIsPictureRequiredAttachmentVisible={
            setIsPictureRequiredAttachmentVisible
          }
          setSingleTaskDetails={setSingleTaskDetails}
          singleTaskDetails={singleTaskDetails}
        />
      )}
    </section>
  );
};
